import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import TitleCell from '../overview/cells/TitleCell'
import Overview from '../overview'
import UnreadByTeam from '../overview/cells/UnreadByTeam'
import DateCell from '../overview/cells/DateCell'
import FormatCell from '../overview/cells/FormatCell'
import UserCell from '../overview/cells/UserCell'
import ActionByUserCell from '../overview/cells/ActionByUserCell'
import IconCell from '../overview/cells/IconCell'
import { ParentCategory } from '../category-selector/CategorySelector'
import { ContentType, IdeationStatus, ModerationLabel, ModeratorTag } from '../overview/filters/types'
import {
  separator,
  publishedIn,
  contentType,
  assignedModerator,
  moderationLabel,
  moderatorTag,
  publishedAt,
  lastActivityAt,
  ideationStatus,
  replies,
  bestAnswer,
  pinnedReply,
  unreadByTeam,
  productArea
} from '../overview/filters/filters'
import { closeTopic } from '../overview/bulk-actions/closeTopic'
import { trashTopic } from '../overview/bulk-actions/trashTopic'
import { moveTo } from '../overview/bulk-actions/moveTo'
import { capitalize, implode } from '../utils/string'

type Props = {
  categories: ParentCategory[],
  contentTypes: ContentType[],
  moderationLabels: ModerationLabel[],
  moderatorTags: ModeratorTag[],
  ideationStatuses: IdeationStatus[],
  allProductAreas: []
}

const ModerationOverview = ({ categories, contentTypes, moderationLabels, moderatorTags, ideationStatuses, allProductAreas }: Props) => {
  function getFilters () {
    return [
      publishedIn(categories),
      contentType(contentTypes),
      separator(),
      assignedModerator(),
      unreadByTeam(),
      moderationLabel(moderationLabels),
      moderatorTag(moderatorTags),
      separator(),
      publishedAt(),
      lastActivityAt(),
      ideationStatus(ideationStatuses),
      separator(),
      replies(),
      separator(),
      bestAnswer(),
      pinnedReply(),
      productArea()
    ]
  }

  function getColumns () {
    return [
      { header: 'Title', accessor: 'title', cell: TitleCell(), size: 'xl', isFixed: true },
      { header: 'Product areas',
        accessor: 'productAreas',
        cell: FormatCell('productAreas',
          (productAreaIds: string[]) => { return implode(productAreaIds.map(id => allProductAreas[Number(id)])) }),
        isHidden: true },
      { header: 'Content type', accessor: 'contentType', cell: FormatCell('contentType', capitalize), size: 'xs' },
      { header: 'Unread by team', accessor: 'moderationStatus', cell: UnreadByTeam(), sorting: 'unreadByTeam', size: 's' },
      { header: 'Published in', accessor: 'categoryName' },
      { header: 'Likes', accessor: 'likes', size: 'xs-right', cell: IconCell('likes', 'like'), isHidden: true },
      { header: 'Replies', accessor: 'replyCount', size: 'xs-right', cell: IconCell('replyCount', 'reply') },
      { header: 'Last activity', accessor: 'lastActivity', cell: ActionByUserCell('lastActivity'), sorting: 'lastActivityAt', size: 'l' },
      { header: 'Assigned moderator', accessor: 'assignedModerator', cell: UserCell('assignedModerator'), isHidden: true },
      { header: 'Publish date', accessor: 'publishDate', cell: DateCell('publishedAt'), sorting: 'publishedAt', isHidden: true },
      { header: 'Author', accessor: 'author', cell: UserCell('author'), isHidden: true },
      { header: 'Moderator tags', accessor: 'moderatorTags', cell: FormatCell('moderatorTags', implode), isHidden: true },
      { header: 'Moderation label', accessor: 'moderationLabel', isHidden: true },
      { header: 'Public tags', accessor: 'publicTags', cell: FormatCell('publicTags', implode), isHidden: true }
    ]
  }

  function getBulkActions () {
    return [
      moveTo(categories),
      closeTopic(),
      trashTopic()
    ]
  }

  return <Overview
    type='moderation'
    headerTitle='Overview'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      unreadByTeam: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    searchPlaceholder='Search in title and content'
    withColumns
    rowId='publicId'
    model={getColumns()}
    endpoint='/overview/topics'
    dataKey='topics'
    bulkActions={getBulkActions()}
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no topics yet'
      text={'Seems like no one on your team has created a topic. \n Start now by creating a new topic.'}
      button={{ link: '/content/new/article', text: 'New article' }}
    />}
    withCustomViews='default'
  />
}

export default ModerationOverview
